import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'elem-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements AfterViewInit {

    private static dragoverListener;

    private static dropListener;

    private readonly INITIAL_LABEL_TEXT = 'Bitte wählen Sie eine Datei oder ziehen diese hierher.';

    @ViewChild('inputTypeFile')
    inputTypeFile: ElementRef;

    @Input()
    errorMessage: string;

    @Output()
    fileSelected = new EventEmitter<Event>();

    @Output()
    fileUnselected = new EventEmitter();

    textLabel: string = this.INITIAL_LABEL_TEXT;

    isSomethingDraggingOver = false;

    isFileSelected = false;

    fileSizeInBytes: number;

    constructor() {
    }

    ngAfterViewInit() {
        this.inputTypeFile.nativeElement.addEventListener(
            'change',
            (event) => this.handleFileInputSelectionUpdate(event),
            false,
        );

        // Verhindere, dass man beim Ziehen ins Upload-Feld versehentlich stattdessen die Datei im Browser-Tab öffnet
        if (!FileUploadComponent.dragoverListener) {
            FileUploadComponent.dragoverListener = window.addEventListener(
                'dragover',
                (e) => e.preventDefault(),
            );
        }

        if (!FileUploadComponent.dropListener) {
            FileUploadComponent.dropListener = window.addEventListener(
                'drop',
                (e) => e.preventDefault(),
            );
        }
    }

    onUnsetFileBtnClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.unsetFileField();
        this.handleFileInputSelectionUpdate(null);
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.isSomethingDraggingOver = true;
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.isSomethingDraggingOver = false;
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.isSomethingDraggingOver = false;

        this.inputTypeFile.nativeElement.files = event.dataTransfer.files;

        this.handleFileInputSelectionUpdate(event);
    }

    unsetFileField() {
        this.inputTypeFile.nativeElement.value = '';
        this.reset();
    }

    private handleFileInputSelectionUpdate(event: DragEvent) {
        const selectedFile = this.getSelectedFile();

        if (!selectedFile) {
            this.fileUnselected.emit();
            this.reset();

            return;
        }

        this.fileSelected.emit(event);

        this.isFileSelected = true;
        this.textLabel = selectedFile.name;
        this.fileSizeInBytes = selectedFile.size;
    }

    private getSelectedFile(): File {
        const inputTypeFileNE = this.inputTypeFile.nativeElement;

        if (!('files' in inputTypeFileNE)) {
            return null;
        }

        const fileList = inputTypeFileNE.files as FileList;

        if (fileList.length < 1) {
            return null;
        }

        return fileList[0];
    }

    private reset() {
        this.isFileSelected = false;
        this.fileSizeInBytes = undefined;
        this.textLabel = this.INITIAL_LABEL_TEXT;
    }

}
